<template>
  <div class="container h-100" >
    <template>
      <div class="d-flex justify-content-center align-items-center h-100" >
        <div class="home-page">
          <b-card>
            <div class="row">
              <div class="col-6 col-lg-3" v-for="(link, index) in data.homeLink" :key="index">
                <a
                  href="javascript:void(0)"
                  class="card-btn d-flex justify-content-center align-items-center"
                  @click="clickCard(link)"
                >
                  <div class="w-100">
                    <i :class="'sprite icons ' + link.icon"></i>
                      <span class="noti-count" v-if="link.count!= null && link.count > 0">{{link.count}}</span>
                      <h5 class="title">{{link.name}}</h5>
                  </div>
                </a>
              </div>
            </div>
          </b-card>
        </div>
      </div>
      <b-modal
        id="modal-center"
        ref="tariff_settings"
        centered
        :title="lang.label.tariffSettings"
        hide-footer
      >
        <ValidationObserver ref="observer" v-slot="{ passes }">
          <b-form @submit.stop.prevent="passes(onSubmit)">
            <div class="row">
              <div class="col-3 col-md-2">
                <label class="label-control mt-2 pt-2">{{lang.label.tariff}}:</label>
              </div>
              <div class="col-9 col-md-10">
                <b-form-group>
                  <ValidationProvider name="Tariff" rules="required" v-slot="validationContext">
                      <b-input-group prepend="R">
                    <b-form-input
                      :state="getValidationState(validationContext)"
                      @keypress="isNumber($event)"
                      v-model="models.tariff"
                      type="text"
                      :placeholder="lang.label.tariff"
                    ></b-form-input>
                    </b-input-group><br />
                    <span v-if="decimalErr" class="error">{{lang.label.decimalErr}}</span>
                    <span v-if="zeroValue && !validationContext.errors[0] && !decimalErr" class="error">{{lang.label.tariffZero}}</span>
                    <span v-if="maxValue && !validationContext.errors[0] && !decimalErr" class="error">{{lang.label.validationMessages.tariffMax}}</span>
                    <span v-if="validationContext.failedRules.required" class="error">{{lang.label.validationMessages.tariffRequired}}</span>
                  </ValidationProvider>
                </b-form-group>
              </div>
              <div class="col-12 mt-3">
                <b-btn type="submit" variant="primary" class="w-100" @click="save">{{lang.label.button.save}}</b-btn>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </b-modal>
      <b-modal
        id="modal-center1"
        ref="contact_details"
        centered
        :title="lang.label.contactDetail"
        hide-footer
      >
        <ValidationObserver ref="observer" v-slot="{ passes }">
          <b-form @submit.stop.prevent="passes(onSubmit)" v-if="details">
            <div class="row">
              <div class="col-5 col-md-4">
                <label class="label-control">{{lang.label.contactNumber}}:</label>
              </div>
              <div class="col-7 col-md-8">
                <label>
                  <a href="tel:+91792517373" class="theme-text">{{details.phone}}</a>
                </label>
              </div>
              <div class="col-5 col-md-4">
                <label class="label-control">{{lang.label.email}}:</label>
              </div>
              <div class="col-7 col-md-8">
                <label>
                  <a :href="'mailto:'+details.email" class="theme-text">{{details.email}}</a>
                </label>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </b-modal>
    </template>
  </div>
</template>

<script>
import jsondata from "../assets/json/data.json";
import moment from 'moment';
import {mapGetters} from "vuex";

export default {
  components: {},
  computed: {
    ...mapGetters({
      login: "login",
      loading: "loading",
    }),
    tariff(){
      return this.models.tariff;
    }
  },
  data() {
    return {
      zeroValue:false,
      maxValue: false,
      decimalErr:false,
      data: jsondata,
      details: '',
      timer: '',
      lang: this.$lang.home,
      models: {
        tariff: ""
      }
    };
  },
  watch: {
    tariff(val){
      this.decimalErr = false;
      if(val < 0) {
        this.zeroValue = false;
        this.maxValue = false;
      } else if (val && parseInt(val) > 100000) {
        this.maxValue = true;
        this.zeroValue = false;
      } else {
        this.maxValue = false;
      }
    }
  },
  mounted(){
    let self = this;
    self.getNotificationsCount();
    this.models.tariff = this.login.myScriptPrice;
    this.timer = setInterval(function () {
      self.getNotificationsCount();
    },5000)
    this.$store.commit("setGroupRequestDetails", {});
    // Fetch doctor data including notificationStatus when home page loads
    self.fetchDoctorDataOnMount();
  },
  methods: {
    fetchDoctorDataOnMount() {
      // Fetch doctor data to get real-time notificationStatus and tariff
      this.$store.dispatch('fetchDoctorData').then(response => {
        if (response && response.status == 200 && response.data) {
          // Handle different response structures (response.data or response.data.data)
          const doctorData = response.data.data || response.data;
          
          // Update notificationStatus if available
          if (doctorData && doctorData.notificationStatus !== undefined) {
            // Update state
            this.$store.commit("setNotificationStatus", doctorData.notificationStatus);
            // Update login data (which saves to localStorage)
            let login = this.login;
            login.notificationStatus = doctorData.notificationStatus;
            this.$store.commit('setLogin', login);
          }
          
          // Update tariff if available
          if (doctorData && doctorData.myScriptPrice !== undefined) {
            this.models.tariff = doctorData.myScriptPrice;
            // Also update login data to keep it in sync
            let login = this.login;
            login.myScriptPrice = doctorData.myScriptPrice;
            this.$store.commit('setLogin', login);
          }
        }
      }).catch(error => {
        // If API fails, continue with existing values
        console.error('Error fetching doctor data on mount:', error);
      });
    },
    getNotificationsCount() {
      this.$store.dispatch('menuNotificationCount').then(response => {
        if (response.status == 200) {
          this.data.homeLink[2].count = response.data.requestCount;
          this.$store.commit("setNotificationStatus", response.data.notificationStatus);
        }
      });
    },
    isNumber: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    open() {
      this.$alert(this.lang.label.scriptCreated, '', {
        confirmButtonText: 'OK',
        callback: action => {
        }
      });
    },
    save() {
      let self = this;
      if (this.models.tariff.toString().includes('.')) {
        this.decimalErr = true;
        return true;
      } else {
        this.decimalErr = false;
      }
      if (parseInt(this.models.tariff) < 0) {
        this.zeroValue = true;
        this.maxValue = false;
        return true;
      } else {
        this.zeroValue = false;
      }
      if (parseInt(this.models.tariff) > 100000) {
        this.maxValue = true;
        this.zeroValue = false;
        return true;
      } else {
        this.maxValue = false;
      }
      if (this.models.tariff >= 0 && parseInt(this.models.tariff) <= 100000) {
        let params = {
          "myScriptPrice": this.models.tariff
        };
        this.$store.dispatch('changeTariff', params).then(value => {
          if (value.data) {
            let login = this.login;
            login.myScriptPrice = value.data.myScriptPrice;
            self.open();
            this.$store.commit('setLogin', login);
            this.$bvModal.hide('modal-center');
          }
        })
      } else {
        this.zeroValue = true;
      }
    },
    clickCard(link) {
      if (link.modal == false) {
        this.$store.commit('setLoading', true);
        this.$router.push({name: link.url});
      } else {
        if (link.code == "contact_details") {
          this.$store.dispatch('contactDetails').then(value => {
            if (value.data) {
              this.details = value.data;
              this.$refs[link.code].show();
            }
          });
        } else if (link.code == "tariff_settings") {
          // Fetch latest tariff data and notificationStatus from API when opening tariff settings modal
          this.$store.dispatch('fetchDoctorData').then(response => {
            if (response && response.status == 200 && response.data) {
              // Handle different response structures (response.data or response.data.data)
              const doctorData = response.data.data || response.data;
              
              // Update notificationStatus if available
              if (doctorData && doctorData.notificationStatus !== undefined) {
                // Update state
                this.$store.commit("setNotificationStatus", doctorData.notificationStatus);
                // Update login data (which saves to localStorage)
                let login = this.login;
                login.notificationStatus = doctorData.notificationStatus;
                this.$store.commit('setLogin', login);
              }
              
              // Update tariff value from API response
              if (doctorData && doctorData.myScriptPrice !== undefined) {
                this.models.tariff = doctorData.myScriptPrice;
                // Also update login data to keep it in sync
                let login = this.login;
                login.myScriptPrice = doctorData.myScriptPrice;
                this.$store.commit('setLogin', login);
              }
            }
            this.$refs[link.code].show();
          }).catch(error => {
            // If API fails, still show modal with current value
            console.error('Error fetching doctor data:', error);
            this.$refs[link.code].show();
          });
        } else {
          this.$refs[link.code].show();
        }
      }
    },
    getValidationState({dirty, validated, valid = null}) {
      return dirty || validated ? valid : null;
    },
    onSubmit() {
    }
  },
  destroyed() {
    clearInterval(this.timer);
  }
}
</script>
